import { useState, useEffect, useRef } from 'react';

/**
 * Input numérique avec :
 * - Sélection automatique du contenu au focus (clic ou Tab)
 * - Virgule et point acceptés comme séparateur décimal (clavier numérique FR)
 * - Affichage formaté à la sortie (decimals=2 → "12,50" ; decimals=0 → "12")
 */
export function NumericInput({ value, onChange, className, style, min, max, decimals = 2, 'data-testid': testId, placeholder }) {
  const toDisplay = (v) => {
    const n = Number(v ?? 0);
    return decimals === 0
      ? String(Math.round(n))
      : n.toFixed(decimals).replace('.', ',');
  };

  const [raw, setRaw] = useState(() => toDisplay(value));
  const prevRef = useRef(value);

  useEffect(() => {
    // Sync seulement si la valeur change de l'extérieur (ex : sélection d'un article)
    if (value !== prevRef.current) {
      prevRef.current = value;
      setRaw(toDisplay(value));
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <input
      type="text"
      inputMode="decimal"
      data-testid={testId}
      placeholder={placeholder}
      className={className}
      style={style}
      value={raw}
      onFocus={e => e.target.select()}
      onChange={e => {
        const typed = e.target.value;
        setRaw(typed);
        const num = parseFloat(typed.replace(',', '.'));
        if (!isNaN(num)) {
          prevRef.current = num;
          onChange(num);
        }
      }}
      onBlur={() => {
        const num = parseFloat(raw.replace(',', '.'));
        let final = isNaN(num) ? 0 : num;
        if (min !== undefined) final = Math.max(Number(min), final);
        if (max !== undefined) final = Math.min(Number(max), final);
        if (decimals === 0) final = Math.round(final);
        prevRef.current = final;
        setRaw(toDisplay(final));
        onChange(final);
      }}
    />
  );
}
